import {configureStore} from '@reduxjs/toolkit'
import {useDispatch, useSelector} from 'react-redux'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import {commonSliceReducer} from '@/store/slices/commonSlice'
import themeReducer from './slices/themeSlice'
import {salesTargetSliceReducer} from '@/store/slices/salesTargetSlice'
import {activitySliceReducer} from '@/store/slices/activitySlice'
import {bulkModifiersSliceReducer} from '@/store/slices/bulkPointSlice'
import {userDetailsSliceReducer} from '@/store/slices/userSlice'
import promotionStepReducer from './slices/promotionStepSlice'
import {countryCodeSliceReducer} from './slices/countryCodeSlice'

// Persist configuration for activity reducer
const activityPersistConfig = {
  key: 'activity',
  storage,
  whitelist: ['activity'], // only activity will be persisted
}

// Create persisted activity reducer
const persistedActivityReducer = persistReducer(activityPersistConfig, activitySliceReducer)

export const reducers = {
  common: commonSliceReducer,
  theme: themeReducer,
  salesTarget: salesTargetSliceReducer,
  activity: persistedActivityReducer,
  bulkModifiers: bulkModifiersSliceReducer,
  userDetails: userDetailsSliceReducer,
  countryCode: countryCodeSliceReducer,
  promotionStep: promotionStepReducer,
}

export const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore persist actions
      },
    }),
})

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export const persistor = persistStore(store)
